import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const SELECTED_ORGANIZATION_ID_KEY = 'selected_organization_id';

export const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    isSidebarMinimized: false,
    selectedOrganizationId: sessionStorage.getItem(
      SELECTED_ORGANIZATION_ID_KEY,
    ) as string | undefined,
  },
  reducers: {
    toggleSidebar: state => {
      state.isSidebarMinimized = !state.isSidebarMinimized;
    },
    setSelectedOrganizationId: (state, action: PayloadAction<string>) => {
      state.selectedOrganizationId = action.payload;
      sessionStorage.setItem(SELECTED_ORGANIZATION_ID_KEY, action.payload);
    },
  },
  selectors: {
    isSidebarMinimizedSelector: state => state.isSidebarMinimized,
    selectedOrganizationIdSelector: state => state.selectedOrganizationId,
  },
});

export const { toggleSidebar, setSelectedOrganizationId } = uiSlice.actions;

export const { isSidebarMinimizedSelector, selectedOrganizationIdSelector } =
  uiSlice.selectors;

export default uiSlice;
